module.exports = __webpack_public_path__ + "img/gsb14.f8ad5383.png";